/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class BlockService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiSupportClientsIdUnblockGet
   */
  static readonly ApiSupportClientsIdUnblockGetPath = '/api/Support/clients/{id}/unblock';

  /**
   * Removing a temporary block from the Client's account.
   *
   * ### Claim
   *  boservice.support.unblock
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportClientsIdUnblockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportClientsIdUnblockGet$Response(params: {

    /**
     * Customer ID
     */
    id: number;

    /**
     * Interface language
     */
    lang?: string;

    /**
     * note from support operator
     */
    note?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, BlockService.ApiSupportClientsIdUnblockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('lang', params.lang, {});
      rb.query('note', params.note, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removing a temporary block from the Client's account.
   *
   * ### Claim
   *  boservice.support.unblock
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportClientsIdUnblockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportClientsIdUnblockGet(params: {

    /**
     * Customer ID
     */
    id: number;

    /**
     * Interface language
     */
    lang?: string;

    /**
     * note from support operator
     */
    note?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.apiSupportClientsIdUnblockGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiSupportClientsIdBlockGet
   */
  static readonly ApiSupportClientsIdBlockGetPath = '/api/Support/clients/{id}/block';

  /**
   * client blocking.
   *
   * ### Claim
   *  boservice.support.setblock
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportClientsIdBlockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportClientsIdBlockGet$Response(params: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * customer id
     */
    id: number;

    /**
     * note from support operator
     */
    note?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, BlockService.ApiSupportClientsIdBlockGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.path('id', params.id, {});
      rb.query('note', params.note, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * client blocking.
   *
   * ### Claim
   *  boservice.support.setblock
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportClientsIdBlockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportClientsIdBlockGet(params: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * customer id
     */
    id: number;

    /**
     * note from support operator
     */
    note?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.apiSupportClientsIdBlockGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
